/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement } from 'solid-element';
import TagEditor, {
  TagEditorProps,
  ITagItem,
  Separators,
  SearchBy,
  IInputCount,
} from './TagEditor';
import { ICustomElement, noShadowDOM } from 'component-register';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-tag-editor': Partial<HTMLElement> &
        TagEditorProps &
        Partial<{ ref: ICustomElement }>;
    }
  }
}

export function defineSolidTagEditor(): void {
  customElement(
    'tc-tag-editor',
    {
      separator: [Separators.ENTER],
      selectedTagList: [],
      matchCase: true,
      title: undefined,
      placeHolder: undefined,
      validateRx: undefined,
      invalidErrorMsg: undefined,
      notFoundErrorMsg: undefined,
      searchBy: SearchBy.LABEL,
      allowCustomTag: false,
      setFocus: false,
      autoSave: false,
      enableSearchIcon: false,
      tagList: [],
      predefinedTagList: [],
      maxLength: undefined,
      customErrorMessage: undefined,
      matchBy: SearchBy.VALUE,
      tagListTitle: undefined,
      inputCount: undefined,
      limitErrorMessage: undefined,
    },
    (props, { element }) => {
      noShadowDOM();

      function handleTagChange(tags: ITagItem[]): void {
        const evt = new CustomEvent<{ tags: ITagItem[] }>('tag-change', {
          detail: { tags },
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      function handleTypeText(query: string): void {
        const evt = new CustomEvent<{ query: string }>('type-text', {
          detail: { query },
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      function handleSearchClose(): void {
        const evt = new CustomEvent('search-close', {
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      return (
        <TagEditor
          separator={props.separator}
          selectedTagList={props.selectedTagList}
          matchCase={props.matchCase}
          title={props.title}
          placeHolder={props.placeHolder}
          validateRx={props.validateRx}
          invalidErrorMsg={props.invalidErrorMsg}
          notFoundErrorMsg={props.notFoundErrorMsg}
          searchBy={props.searchBy}
          allowCustomTag={props.allowCustomTag}
          setFocus={props.setFocus}
          autoSave={props.autoSave}
          enableSearchIcon={props.enableSearchIcon}
          tagList={props.tagList}
          predefinedTagList={props.predefinedTagList}
          maxLength={props.maxLength}
          customErrorMessage={props.customErrorMessage}
          matchBy={props.matchBy}
          tagListTitle={props.tagListTitle}
          inputCount={props.inputCount}
          limitErrorMessage={props.limitErrorMessage}
          onTagChange={handleTagChange}
          onTypeText={handleTypeText}
          onSearchClose={handleSearchClose}
        />
      );
    }
  );
}

// Re-export types for convenience
export type { TagEditorProps, ITagItem, IInputCount };
export { Separators, SearchBy };
